import { render } from "./Oferta.vue?vue&type=template&id=a7ba5d0c&scoped=true"
import script from "./Oferta.vue?vue&type=script&lang=js"
export * from "./Oferta.vue?vue&type=script&lang=js"

import "./Oferta.vue?vue&type=style&index=0&id=a7ba5d0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7ba5d0c"]])

export default __exports__